export default "__VITE_ASSET__f92200d3__"